<div *ngIf="isLoaded"
	 class="lp-badge"
	 [class.lp-badge-clickable]="linkToSightSchool"
	 [ngClass]="'lp-badge-' + award.toLowerCase()"
	 [ngStyle]="containerStyle"
	 [title]="award === 'None' ? 'No SightSchool award yet — click to view progress' : (award + ' award — click to view progress')"
	 (click)="onClick($event)">
	<img [src]="iconUrl" [alt]="award + ' award'" class="lp-badge-img" />
</div>
